module.exports = "/images/vendor/flag-icon-css/flags/4x3/yt.svg?f06d254d5978e4b0223fa242514e55e1";